import { Minus, Plus, Trash2, ImageIcon } from "lucide-react";
import { cart } from "../../lib/cart";
import { assetUrl, money } from "../../lib/shopApi";

export const CartLines = ({ items }) => (
  <ul className="divide-y divide-[#E7DFD5]" data-testid="shop-cart-lines">
    {items.map((x) => (
      <li key={x.variant_id} className="py-4 flex gap-3" data-testid={`shop-cart-line-${x.variant_id}`}>
        <div className="w-16 h-16 rounded bg-white border border-[#E7DFD5] overflow-hidden flex-shrink-0">
          {x.image ? <img src={assetUrl(x.image)} alt="" className="w-full h-full object-contain" /> : <div className="w-full h-full bg-[#EFE6D8] flex items-center justify-center text-[#B9A58E]"><ImageIcon size={18} /></div>}
        </div>
        <div className="flex-1 min-w-0">
          <p className="font-display text-lg text-[#4B3A2F] leading-tight truncate">{x.title}</p>
          {x.variant_label && <p className="text-xs text-[#6D5A50]">{x.variant_label}</p>}
          <div className="flex items-center gap-2 mt-2">
            <button type="button" aria-label="Less" onClick={() => cart.setQty(x.variant_id, x.quantity - 1)} className="p-1 rounded-full border border-[#D9CBB8]" data-testid={`shop-cart-minus-${x.variant_id}`}><Minus size={12} /></button>
            <span className="w-6 text-center text-sm">{x.quantity}</span>
            <button type="button" aria-label="More" onClick={() => cart.setQty(x.variant_id, x.quantity + 1)} className="p-1 rounded-full border border-[#D9CBB8]" data-testid={`shop-cart-plus-${x.variant_id}`}><Plus size={12} /></button>
            <button type="button" aria-label="Remove" onClick={() => cart.setQty(x.variant_id, 0)} className="ml-2 text-[#8D6E63] hover:text-[#D62839]" data-testid={`shop-cart-remove-${x.variant_id}`}><Trash2 size={14} /></button>
          </div>
        </div>
        <p className="text-sm text-[#4B3A2F]">{money(x.price * x.quantity)}</p>
      </li>
    ))}
  </ul>
);
